import styled from 'styled-components';
import Text from './Text';
var Italic = styled(Text).attrs(function (_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'em' : _ref$as;
  return {
    as: as
  };
}).withConfig({
  displayName: "Italic",
  componentId: "sc-1pf8qfw-0"
})(["font-style:italic;"]);
export default Italic;